/**
 * 
 */
export default function altTextKes(altText, count) {
  if (!altText) return null;

  const words = altText.replace(/(\n+ *)+/g, "\n").split(/\s/)
  let output = ""
  
  for (const word of words) {
    if (output.length + word.length > count) break;
    output = output+" "+word;
  }
  if(count - output.length >= 3) {
    output = output+"...";
  }
  return output;
} 
